import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import merchantDownload from '@/components/merchantDownload'
import secondpage from '@/components/secondpage'
import about from '@/components/about'
import download from '@/components/download'
import business from '@/components/business'
import newsandinformation from '@/components/newsandinformation'
import contactus from '@/components/contactus'
import userAgreement from '@/components/userAgreement'
import horsemanLoginAgreement from '@/components/horsemanLoginAgreement'
import horsemanAgreement from '@/components/horsemanAgreement'
import concealAgreement from '@/components/concealAgreement'
import businessAgreement from '@/components/businessAgreement'
import merchantPolicy from '@/components/merchantPolicy'
import businessDown from '@/components/businessDown'

/*  */
import three from '@/components/three'


Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [{
			path: '/',
			name: 'HelloWorld',
			component: HelloWorld
		},
		{
			path: '/merchantdownload',
			name: 'merchantdownload',
			component: merchantDownload
		},
		
		{
			path: '/secondpage',
			name: 'secondpage',
			component: secondpage
		},
		{
			path: '/about',
			name: 'about',
			component: about
		},
		
		{
			path: '/download',
			name: 'download',
			component: download
		},
		{
			path: '/business',
			name: 'business',
			component: business
		},
		{
			path: '/newsandinformation',
			name: 'newsandinformation',
			component: newsandinformation
		},
		{
			path: '/contactus',
			name: 'contactus',
			component: contactus
		},
		{
			path: '/userAgreement',
			name: 'userAgreement',
			component: userAgreement
		},
		{
			path: '/horsemanLoginAgreement',
			name: 'horsemanLoginAgreement',
			component: horsemanLoginAgreement
		},
		{
			path: '/horsemanAgreement',
			name: 'horsemanAgreement',
			component: horsemanAgreement
		},
		{
			path: '/concealAgreement',
			name: 'concealAgreement',
			component: concealAgreement
		},
		{
			path: '/businessAgreement',
			name: 'businessAgreement',
			component: businessAgreement
		},
		{
			path: '/merchantPolicy',
			name: 'merchantPolicy',
			component: merchantPolicy
		},
		{
			path: '/businessDown',
			name: 'businessDown',
			component: businessDown
		}
		// {
		// 	path: '/three',
		// 	name: 'three',
		// 	component: three
		// }
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js